jQuery(document).ready(function(jQuery) {

  // AVADA JOY

//<script src="https://cdn.shopify.com/extensions/0087e139-9c3f-4e5a-b860-82fcb0939a91/inbox-318/assets/inbox-chat-loader.js" type="text/javascript" defer="defer"></script>
  
  var joySterneBtn = document.getElementById('joySterne');
  var avada_joy_url = 'https://cdn.shopify.com/extensions/87c755b3-9fe6-4267-93c8-cbd41d8de658/joy-loyalty-program-38/assets/avada-joy.js';
  function openAvadaJoy() {
    let elm = jQuery('#Avada-Joy_FloatingButtonTrigger');
    if (elm.length === 0) {
      setTimeout(openAvadaJoy, 500);
    } else {
      jQuery('#Avada-Joy_FloatingButtonTrigger').click()
    }
  }
  function loadAvadaJoy(url, open) {
    if (document.getElementById('joy-script') !== null) {
       return openAvadaJoy();
    }
    var s = document.createElement("script");
    s.setAttribute("id", 'joy-script');
    s.setAttribute("type", "text/javascript");
    s.setAttribute("src", url);
    if (open) s.onload = setTimeout(openAvadaJoy, 500);
    document.body.appendChild(s);
  }

  if(typeof joySterneBtn !== 'undefined' && joySterneBtn !== null) {
    joySterneBtn.addEventListener('click', function(e) {
      loadAvadaJoy(avada_joy_url, true);
      this.remove();
    });
  }
  
  var joy_links = document.getElementsByClassName('link-joy')[0];
  joy_links.addEventListener('click', function(e) {
      loadAvadaJoy(avada_joy_url, true);
  });

  jQuery(window).bind('hashchange', function() {
    if (window.location.hash == '#sterne') {
      loadAvadaJoy(avada_joy_url, true);
    }
  });
  if (window.location.hash == '#sterne') {
    loadAvadaJoy(avada_joy_url, false);
  }
  

  // PARTNER 
  
  if (location.pathname.indexOf('/partner/') === 0) {
    window.location.href = location.href.replace('/partner/', '?sPartner=');
  }  

  let partner_key = 'sPartner';

  // set partner_id if in url
  let url_params = window.location.search;
  let partner_pos = url_params.indexOf(partner_key);
  if (partner_pos !== -1) {
    Cookies.set(partner_key, url_params.substring(partner_pos + partner_key.length + 1), { expires: 30, path: '/' });
    // window.location.href = location.href.replace('sPartner', 'ref');
  }


  let partner_id = Cookies.get(partner_key);

  
  if (partner_id && cart_note != 'P-' + partner_id) {
    jQuery.ajax({
      url: '/cart/update.js',
      type: 'POST',
      data: {note: 'P-' + partner_id}
    });
  }


  
  // ADCELL
  let ac_key = '_adcell';
  let ac_url = new URL(window.location.href);
  let ac_params = ac_url.searchParams; 
  let ac_bid = ac_params.get('bid');
  if (ac_bid) {
    Cookies.set(ac_key, ac_bid, { expires: 30, path: '/' });
  }
  let ac_sess = Cookies.get(ac_key);
  if (ac_sess) {
    let script = document.createElement('script');
    script.src = 'https://t.adcell.com/js/trad.js';
    document.head.append(script);
    script.onload = function () {
      Adcell.Tracking.track();
    };
    if (cart_note != 'adcell') {
      jQuery.ajax({
        url: '/cart/update.js',
        type: 'POST',
        data: {note: 'adcell'}
      });
    }
  }


  // REFERRER
  let lang_key = '_lang';
  let lang_sess = Cookies.get(lang_key);
  let referrer = document.referrer;
  if (referrer) {
    if (referrer.includes('.kokadi.')) {
      var domain_regex = /(?:[\w-]+\.)+[\w-]+/
      var domain_referrer = domain_regex.exec(referrer)[0];
      if (domain_referrer != window.location.hostname) {
        console.log(domain_referrer +'--'+ window.location.hostname);
        var last_domain_lang = domain_referrer.replace('https://','').replace('kokadi','').replace('www.','').replace('.com','').replace('.','').toUpperCase();
        if (last_domain_lang.length == 2 && last_domain_lang != lang_sess && last_domain_lang != 'DE' && last_domain_lang != 'EN') {
          Cookies.set(lang_key, last_domain_lang+'|'+domain_referrer, { expires: 30, path: '/' });
          lang_sess = last_domain_lang+'|'+domain_referrer;
        }
      }
    }    
  }
  if (lang_sess) {
    let last_lang = lang_sess.split('|');
    //jQuery('.lang-switcher').append('<a href="https://'+last_lang[1]+document.location.pathname+'">'+last_lang[0]+'</a>');
  }

});


var jdgmpreviewbadge = document.querySelector('.jdgm-preview-badge--with-link');
if (jdgmpreviewbadge) {
  jdgmpreviewbadge.addEventListener('click', (e) =>{
    if(!e.target.classList.contains('jdgm-qa-badge__text')) return;
    window.open('tel:+4989248810444','_self');
    e.preventDefault();
    return false;
  }); 
}
  